<template>
  <div>
    <v-container pa-0 fluid>
      <v-row align="center" justify="space-between" class="font-weight-black">
        <v-col cols="12" sm="11" class="pa-0">
          <v-breadcrumbs :items="breadcrumbs" divider="/">
            <template v-slot:item="props">
              <v-breadcrumbs-item
                :disabled="props.item.disabled"
                :class="{
                  'LiquidacaoNivel_breadcrumbs-item': true,
                  'LiquidacaoNivel_breadcrumbs-item_disabled': props.item.disabled,
                }"
                @click.native="navegarBreadcrumbs(props.item)">
                {{ props.item.text }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="1" class="text-right pa-0 pr-3" v-if="exibirFiltro">
          <v-icon v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
        </v-col>
      </v-row>
    </v-container>

    <liquidacao-filtro
      v-model="abrirFiltro"
      v-if="exibirFiltro"
      entidade-workspace="liquidacao"
      @LiquidacaoFiltro__AplicaFiltros="aplicarFiltros">
    </liquidacao-filtro>

    <liquidacao-cards-totalizadores
      ref="cards_totalizadores"
      v-if="exibirFiltro"
      :filtros="filtros"
      percentual="monetario">
    </liquidacao-cards-totalizadores>

    <transition name="slide-fade"
                mode="out-in">
      <router-view></router-view>
    </transition>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LiquidacaoFiltro from '@/spa/liquidacao-contrato/LiquidacaoFiltro';
import { generateComputed } from '../../common/functions/roles-computed-generator';
import Confirm from '../../shared-components/vuetify/dialog/Confirm';
import LiquidacaoCardsTotalizadores from './LiquidacaoCardsTotalizadores';
import LiquidacaoControleBreadcrumbs from './LiquidacaoControleBreadcrumbs';

export default {
  data() {
    return {
      abrirFiltro: false,
      filtros: null,
    };
  },
  mixins: [LiquidacaoControleBreadcrumbs],
  components: {
    Confirm,
    LiquidacaoFiltro,
    LiquidacaoCardsTotalizadores,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    ...generateComputed('CTRT_PGTO', [
      'canAccessPage',
    ]),
  },
  methods: {
    ...mapActions('filtros', [
      'setFiltroLiquidacaoContrato',
      'setFiltroLiquidacaoContratoNivel1',
    ]),
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast(this.$t('message.acesso_negado'));
      }
    },
    aplicarFiltros(filtrosAplicados) {
      if (!filtrosAplicados || !this.filtroPeriodoValido(filtrosAplicados)) {
        return;
      }
      const filtros = {
        ...filtrosAplicados,
        visao: 'visao_contrato',
      };
      this.filtros = filtros;
      this.setFiltroLiquidacaoContrato(filtros);
      this.setFiltroLiquidacaoContratoNivel1(null);
    },
    filtroPeriodoValido(filtrosAplicados) {
      if (filtrosAplicados.data_inicio || filtrosAplicados.data_fim) {
        let dtInicio = '';
        let dtFinal = '';
        dtInicio = this.moment(filtrosAplicados.data_inicio, 'YYYY-MM-DD');
        dtFinal = this.moment(filtrosAplicados.data_fim, 'YYYY-MM-DD');

        if (dtFinal.isBefore(dtInicio)) {
          this.$toast(this.$t('message.data_final_antes_inicial'));
          return false;
        }
        if ((filtrosAplicados.data_inicio && !filtrosAplicados.data_fim)
            || (!filtrosAplicados.data_inicio && filtrosAplicados.data_fim)) {
          this.$toast(this.$t('message.data_final_e_inicial'));
          return false;
        }
        return true;
      }
      return true;
    },
  },
  beforeMount() {
    this.setFiltroLiquidacaoContrato(null);
    this.setFiltroLiquidacaoContratoNivel1(null);
    this.setFiltroLiquidacaoContratoNivel2(null);
  },
  mounted() {
    window.setTimeout(() => this.accessForbidden(), 1E3);
  },
};
</script>
<style lang="scss">
  .Barra_Breadcrumbs {
    .v-breadcrumbs {
      padding: 0.5em 0 1em 0;
    }
    ul:not(.md-list)>li+li {
      margin-top: 0 !important;
    }
  }
  .Barra_Exibicao {
    min-height: 41px !important;
    text-align: center;
    padding: 8px 0;
  }
  .Barra_Exibicao div.v-input__slot, .Barra_Exibicao div.v-messages, .Barra_Exibicao .v-icon {
    margin: 0 !important;
    padding: 0;
    min-height: 0;
  }
  .Barra_Pesquisa {
    width: 33%;
  }
  .LiquidacaoNivel_breadcrumbs-item_disabled {
    color: grey;
    pointer-events: none;
  }
  .LiquidacaoNivel_breadcrumbs-item {
    color: grey;
    cursor: pointer;
  }
  .LiquidacaoNivel_breadcrumbs-item:hover {
    color: #3f3f3f;
  }
</style>
